import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useQueryRequest } from './QueryRequestProvider'
import { getProfisionaisDeSaude } from './_requests'
import {
  createResponseContext,
  initialQueryResponse,
  WithChildren,
  stringifyRequestQuery,
  QUERIES,
} from '_metronic/helpers'
import { useModal } from 'app/components'
import { PessoaList } from 'app/modules/auth'

const QueryResponseContext = createResponseContext<PessoaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.ESPECIALISTAS_LIST, query, isOpen], () => getProfisionaisDeSaude(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
